import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    labels: {
      amount: "VAT's amount",
      rate: 'Rate',
    },
    placeholders: {
      amount: 'Amount',
      rate: 'Choose',
    },
  },
  fr: {
    labels: {
      amount: 'Montant de la TVA',
      rate: 'Taux',
    },
    placeholders: {
      amount: 'Montant',
      rate: 'Choisir',
    },
  },
} as const);

export default locales;
